// extracted by mini-css-extract-plugin
module.exports = {"card":"card--bhqBk","card_header":"card_header--2c93s","card_header_title":"card_header_title--ymuRI","content_column3":"content_column3--1v9F7"};